import { TableBody, TableCell } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useAttendance } from '../../../hooks/Features/useAttendance'
import { itemsPerPage } from '../../../shared/data'
import CustomHeading from '../../CustomHeading'
import CustomPagination from '../../CustomPagination'
import InProgress from '../../InProgress'
import Layout from '../../Layout'
import Loader from '../../Loader'
import CustomTable from '../../Table/CustomTable'
import CustomTableHeading from '../../Table/CustomTableHeading'
import CustomTableRow from '../../Table/CustomTableRow'
import styles from '../reports.module.css'

export default function TrainingReport() {
    return (
        <Layout heading="Training Report" none>
            <InProgress />
        </Layout>
    )
}
